var offsetX = 8;
var offsetY = 65;
var width = 80;
var height = 48;
var rotate = 0;
var marginX = 10.0;
var marginY = 10.0;
var contentWidth = width - marginX * 2;
var qrCodeHeight = (height - 10) - marginY * 2;
var qrCodeWidth = qrCodeHeight;
var fontSize = 3.1;

//组合打印数据
export const combinationPrintData = {
    InitDrawingBoardParam: {
        width,
        height,
        rotate,
        path: "ZT001.ttf",
        verticalShift: 0,
        HorizontalShift: 0
    },
    elements: [
        {
            type: 'text',
            json: {
                x: offsetX ,
                y:0,
                height: 8,
                width: offsetY,
                value: null,
                fontFamily: "宋体",
                rotate: 0,
                fontSize,
                textAlignHorizonral: 0,
                textAlignVertical: 1,
                letterSpacing: 0.0,
                lineSpacing: 1.0,
                lineMode: 6,
                fontStyle: [false, false, false, false],
            }
        },
        {
            type: 'text',
            json: {
                x: offsetX ,
                y:6,
                height: offsetX,
                width: offsetY,
                value: null,
                fontFamily: "宋体",
                rotate: 0,
                fontSize,
                textAlignHorizonral: 0,
                textAlignVertical: 1,
                letterSpacing: 0.0,
                lineSpacing: 1.0,
                lineMode: 6,
                fontStyle: [false, false, false, false],
            }
        },
        {
            type: 'text',
            json: {
                x: offsetX ,
                y:12,
                height: offsetX,
                width: offsetY,
                value: null,
                fontFamily: "宋体",
                rotate: 0,
                fontSize,
                textAlignHorizonral: 0,
                textAlignVertical: 1,
                letterSpacing: 0.0,
                lineSpacing: 1.0,
                lineMode: 6,
                fontStyle: [false, false, false, false],
            }
        },
        {
            type: 'text',
            json: {
                x: offsetX ,
                y:18,
                height: offsetX,
                width: offsetY,
                value: null,
                fontFamily: "宋体",
                rotate: 0,
                fontSize,
                textAlignHorizonral: 0,
                textAlignVertical: 1,
                letterSpacing: 0.0,
                lineSpacing: 1.0,
                lineMode: 6,
                fontStyle: [false, false, false, false],
            }
        },
        {
            type: 'text',
            json: {
                x: offsetX ,
                y:24,
                height: offsetX,
                width: offsetY,
                value: null,
                fontFamily: "宋体",
                rotate: 0,
                fontSize,
                textAlignHorizonral: 0,
                textAlignVertical: 1,
                letterSpacing: 0.0,
                lineSpacing: 1.0,
                lineMode: 6,
                fontStyle: [false, false, false, false],
            }
        },
        {
            type: 'text',
            json: {
                x: offsetX ,
                y:30,
                height: offsetX,
                width: offsetY,
                value: null,
                fontFamily: "宋体",
                rotate: 0,
                fontSize,
                textAlignHorizonral: 0,
                textAlignVertical: 1,
                letterSpacing: 0.0,
                lineSpacing: 1.0,
                lineMode: 6,
                fontStyle: [false, false, false, false],
            }
        },
        {
            type: 'qrCode',
            json: {
                x: 50,
                y: 27,
                height: qrCodeHeight,
                width: qrCodeWidth,
                value: null,
                codeType: 31,
                rotate: 0
            }
        },
    ]
};

// export const fangjianming = {
//     type: 'text',
//     json: {
//         x: marginX + offsetX,
//         y: offsetY + qrCodeHeight - 1,
//         height: height - qrCodeHeight,
//         width: width - marginX * 2,
//         value: "安吉公务员住宅小区2栋1单元2703",
//         fontFamily: "宋体",
//         rotate: 0,
//         fontSize,
//         textAlignHorizonral: 0,
//         textAlignVertical: 1,
//         letterSpacing: 0.0,
//         lineSpacing: 1.0,
//         lineMode: 6,
//         fontStyle: [true, false, false, false],
//     }
// };

export default {combinationPrintData};
